// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { IsAllowed } from '../../IsAllowed';
import { AccountSummaryTablesEnum } from './AccountSummaryTablesEnum';
import { TvBaseColumns } from './TvBaseColumns';
import { TvColDefVisEnum } from './TvColumnDefaultVisibilityEnum';
class _TvAccountColumns extends TvBaseColumns {
    constructor() {
        super();
        this.defaultalignment = 'left';
    }
    getColumns(subTableType) {
        let columns = [];
        switch (subTableType) {
            case AccountSummaryTablesEnum.General:
                columns = this.getGeneralColumns();
                break;
            case AccountSummaryTablesEnum.Margin:
                columns = this.getMarginColumns();
                break;
            case AccountSummaryTablesEnum.AccountActivity:
                columns = this.getAccountActivityColumns();
                break;
            case AccountSummaryTablesEnum.TodaysResults:
                columns = this.getTodaysResultsColumns();
                break;
        }
        return columns.filter((c) => c !== null);
    }
    getGeneralColumns() {
        const balanceColumn = this.createAccSummaryColumnItem('panel.accounts.Balance', 'balance', 'balanceFormatter', TvColDefVisEnum.Visible);
        const projectedBalanceColumn = this.createAccSummaryColumnItem('panel.accounts.CurBalance', 'projectedBalance', 'projectedBalanceFormatter', TvColDefVisEnum.Hidden);
        const availableFundsColumn = this.createAccSummaryColumnItem('panel.accounts.AvailableMargin', 'availableFunds', 'availableFundsFormatter', TvColDefVisEnum.Visible);
        const blockedBalanceColumn = this.createAccSummaryColumnItem('panel.accounts.LockedBalance', 'blockedBalance', 'blockedBalanceFormatter', TvColDefVisEnum.Hidden);
        const unsettledCashColumn = this.createAccSummaryColumnItem('panel.accounts.UnsettledCash', 'unsettledCash', 'unsettledCashFormatter', TvColDefVisEnum.Hidden);
        const result = [
            balanceColumn,
            projectedBalanceColumn,
            availableFundsColumn,
            blockedBalanceColumn,
            unsettledCashColumn
        ];
        if (IsAllowed.IsCopyTradingAllowed()) {
            const copyTrading = this.createAccSummaryColumnItem('panel.accounts.CopyTrading', 'copyTrading', 'copyTradingFormatter', TvColDefVisEnum.Visible);
            result.push(copyTrading);
        }
        return result;
    }
    getMarginColumns() {
        const initialMarginReqColumn = this.createAccSummaryColumnItem('panel.accounts.MarginUsedNew', 'initialMarginReq', 'initialMarginReqFormatter', TvColDefVisEnum.Visible);
        const initialMarginReqPercentColumn = this.createAccSummaryColumnItem('panel.accounts.CurMargin', 'initialMarginReqPercent', 'initialMarginReqPercentFormatter', TvColDefVisEnum.Hidden);
        const maintMarginReqColumn = this.createAccSummaryColumnItem('panel.accounts.MarginStopOut', 'maintMarginReq', 'maintMarginReqFormatter', TvColDefVisEnum.Hidden);
        const maintMarginReqPercentColumn = this.createAccSummaryColumnItem('panel.accounts.MaintMargin', 'maintMarginReqPercent', 'maintMarginReqPercentFormatter', TvColDefVisEnum.Hidden);
        const marginWarningLevelColumn = this.createAccSummaryColumnItem('panel.accounts.marginWarnPercent', 'marginWarningLevel', 'marginWarningLevelFormatter', TvColDefVisEnum.Hidden);
        const marginAvailableColumn = this.createAccSummaryColumnItem('panel.accounts.MarginAvailableReal', 'marginAvailable', 'marginAvailableFormatter', TvColDefVisEnum.Visible);
        const warningMarginColumn = this.createAccSummaryColumnItem('panel.accounts.MarginWarning', 'warningMargin', 'warningMarginFormatter', TvColDefVisEnum.Hidden);
        const blockedForStocksColumn = this.createAccSummaryColumnItem('panel.accounts.BlockedForStocksNew', 'blockedForStocks', 'blockedForStocksFormatter', TvColDefVisEnum.Hidden);
        const stocksOrdersReqColumn = this.createAccSummaryColumnItem('panel.accounts.StocksOrdersReq', 'stocksOrdersReq', 'stocksOrdersReqFormatter', TvColDefVisEnum.Hidden);
        return [
            initialMarginReqColumn,
            initialMarginReqPercentColumn,
            maintMarginReqColumn,
            maintMarginReqPercentColumn,
            marginWarningLevelColumn,
            marginAvailableColumn,
            warningMarginColumn,
            blockedForStocksColumn,
            stocksOrdersReqColumn
        ];
    }
    getAccountActivityColumns() {
        const openGrossPLColumn = this.createAccSummaryColumnItem('panel.accounts.Profit', 'openGrossPL', 'openGrossPLFormatter', TvColDefVisEnum.Visible);
        const openNetPLColumn = this.createAccSummaryColumnItem('panel.accounts.ProfitNet', 'openNetPL', 'openNetPLFormatter', TvColDefVisEnum.Visible);
        const openPositionsCountColumn = this.createAccSummaryColumnItem('panel.accounts.Positions', 'openPositionsCount', 'openPositionsCountFormatter', TvColDefVisEnum.Hidden);
        const openOrdersCountColumn = this.createAccSummaryColumnItem('panel.accounts.Orders', 'openOrdersCount', 'openOrdersCountFormatter', TvColDefVisEnum.Hidden);
        return [openGrossPLColumn, openNetPLColumn, openPositionsCountColumn, openOrdersCountColumn];
    }
    getTodaysResultsColumns() {
        const todaysGrossColumn = this.createAccSummaryColumnItem('panel.accounts.GrossPNL', 'todaysGross', 'todaysGrossFormatter', TvColDefVisEnum.Visible);
        const todaysNetColumn = this.createAccSummaryColumnItem('panel.accounts.BeginBalance', 'todaysNet', 'todaysNetFormatter', TvColDefVisEnum.Visible);
        const todaysFeesColumn = this.createAccSummaryColumnItem('panel.accounts.TodayFees', 'todaysFees', 'todaysFeesFormatter', TvColDefVisEnum.Visible);
        const todaysVolumeColumn = this.createAccSummaryColumnItem('panel.accounts.TodayVolume', 'todaysVolume', 'todaysVolumeFormatter', TvColDefVisEnum.Visible);
        const todaysTradesColumn = this.createAccSummaryColumnItem('panel.accounts.TodayTrades', 'todaysTrades', 'todaysTradesFormatter', TvColDefVisEnum.Visible);
        return [todaysGrossColumn, todaysNetColumn, todaysFeesColumn, todaysVolumeColumn, todaysTradesColumn];
    }
}
export const TvAccountColumns = new _TvAccountColumns();
